import { envConfig } from '../../../config/envConfig'
import { AppConfigurationKey } from '../../../model/enums/appConfigurationKey'
import AxiosInstance from '../../http-config'

export class ApiAppConfiguration {
  getKeyValuePairs = async () => {
    return await AxiosInstance.post(
      `${envConfig.prefixes.frontServices}/GetAppConfiguration`,
      {
        keys: Object.values(AppConfigurationKey).filter(key =>
          isNaN(Number(AppConfigurationKey[key]))
        )
      },
      {
        baseURL: process.env.REACT_APP_API_MANAGEMENT_HOST,
        headers: {
          'Ocp-Apim-Subscription-Key': envConfig.subscriptions.front
        }
      }
    ).then(response => {
      return response.data
    })
  }
}
